<script>
import appConfig from "@/app.config.json";
import tableSearch from "@/mixins/tableSearch";
import router from "@/mixins/router";
import Layout from "@/views/layouts/main.vue";
import apiEndpoints from "@/services/apiEndpoints";
import WorkOrderInformationComponent from "@/views/pages/project/schedule/components/work_order_information.vue";
import WorkReservationInformationComponent from "@/views/pages/project/schedule/components/work_reservation_information.vue";
import RegularlyReservationComponent from "@/views/pages/project/schedule/components/regularly_reservation.vue";
import workReservationSchedule from "@/mixins/workReservationSchedule";
import WorkReservationSpecificDatesInformation
  from "@/views/pages/project/schedule/components/work_reservation_specific_dates_information.vue";
import ModalHistory from "@/views/pages/project/schedule/modals/ModalHistory";
import ModalScheduleCar from "@/views/pages/project/schedule/modals/ModalScheduleCar.vue";
import ModalTransportTreatment from "@/views/pages/project/schedule/modals/ModalTransportTreatment.vue";
import ModalSelectWasteOrServiceModalForSchedule
  from "@/views/pages/project/schedule/modals/ModalSelectWasteOrServiceModalForSchedule.vue";
import ModalScheduleStaff from "@/views/pages/project/schedule/modals/ModalScheduleStaff.vue";
import CommonTableComponent from "@/components/table.vue";
import ZzReservationStatus1Badge from "@/components/Common/ZzReservationStatus1Badge.vue";
import ZzReservationStatus2Badge from "@/components/Common/ZzReservationStatus2Badge.vue";
import ScheduleRegularIntervalInformationBySale
  from "@/views/pages/project/schedule/components/schedule_regular_interval_information_by_sale.vue";
import ScheduleRegularIntervalInformationByCarManager
  from "@/views/pages/project/schedule/components/schedule_regular_interval_information_by_car_manager.vue";
import ModalConfirmRegularUpdate
  from "@/views/pages/project/schedule/modals/ModalConfirmRegularUpdate.vue";
import ModalConfirmRegularDelete
  from "@/views/pages/project/schedule/modals/ModalConfirmRegularDelete.vue";
import constant from "@/configs/constant";
import number from "@/mixins/number";
import sweetAlert from "@/mixins/sweetAlert";
import user from "@/mixins/user";
import { forEach } from "lodash";

export default {
  name: "RegularScheduleWorkReservation",
  page: {
    title: "スケジュール詳細",
    meta: [{ name: "description", content: appConfig.description }]
  },
  props: {
    workReservation: {
      type: Object,
      required: true
    },
  },
  mixins: [tableSearch, router, workReservationSchedule, number, sweetAlert, user],
  components: {
    ZzReservationStatus2Badge, ZzReservationStatus1Badge, CommonTableComponent,
    ModalScheduleStaff, ModalTransportTreatment, ModalScheduleCar,
    WorkReservationSpecificDatesInformation,
    Layout,
    WorkOrderInformationComponent,
    WorkReservationInformationComponent,
    RegularlyReservationComponent,
    ScheduleRegularIntervalInformationBySale,
    ScheduleRegularIntervalInformationByCarManager,
    ModalConfirmRegularUpdate,
    ModalConfirmRegularDelete,
    ModalSelectWasteOrServiceModalForSchedule,
    ModalHistory,
  },
  data() {
    return {
      buttonCancelText: this.$lang.button.cancel,
      workOrder: null,
      allSchedule: [],
      schedules: [],
      errors: {},
      regularInformation: {
        regularly_reservation_date_of_month: "",
        regularly_reservation_day_of_week: [],
        regularly_reservation_end_date: "",
        regularly_reservation_start_date: "",
        schedule_type:"regular_reservation",
        zz_day_of_time_zone_id: "",
        zz_regularly_reservation_interval_id: "",
        start_time: "",
        end_time: "",
      },
      isAlreadyMapping: false,
      update_request: 0,
      schedule_id: null,
      tab: null,
      selectedSchedule: null,
    };
  },
  async created() {
    this.update_request = this.$route.query.update_request ?? 0;
    this.schedule_id = this.$route.query.schedule_id ?? null;
    this.tab = this.$route.query.tab ?? null;
    await this.getSchedules();
  },
  methods: {
    mappingData(result) {
      if (this.isAlreadyMapping) return;

      this.workReservation = result;
      this.workOrder = result?.work_order;
      const startTime = this.$moment(this.schedules[0].start_datetime).format('HH:mm');
      const endTime = this.$moment(this.schedules[0].end_datetime).format('HH:mm');
      this.regularInformation = {
        regularly_reservation_date_of_month: result.regularly_reservation_date_of_month,
        regularly_reservation_day_of_week: result.regularly_reservation_day_of_week,
        regularly_reservation_start_date: result.regularly_reservation_start_date,
        regularly_reservation_end_date: result.regularly_reservation_end_date,
        schedule_type:"regular_reservation",
        zz_day_of_time_zone_id: result?.reservation_dates_by_work_reservation[0]?.zz_day_of_time_zone_id,
        zz_regularly_reservation_interval_id: result.zz_regularly_reservation_interval_id,
        start_time: startTime,
        end_time: endTime,
      }

      this.isAlreadyMapping = true;
    },
    async getSchedules() {
      const startDatetime = this.$moment().format("YYYY-MM-DD");
      const {status, code, data} = await this.$http.get(apiEndpoints.list_schedule_by_work_reservation_edit(this.workReservationId), {
        schedule_id: this.scheduleId,
        start_datetime: this.scheduleId ? '' : startDatetime,
        zz_reservation_frequency_type_id: this.$constant.zzReservationFrequencyTypeId.regularly,
      })
      if (!status) {
        return this.errorToast(data.message);
      }
      if (data.result.length) {
        const dataSchedules = data.result;
        this.allSchedule = data.result;

        const confirmedCount = dataSchedules.filter(item => item.zz_reservation_status_1_id === '5').length;

        dataSchedules.sort((a, b) => new Date(a.start_datetime) - new Date(b.start_datetime));

        if (confirmedCount === dataSchedules.length) {
          this.schedules = [dataSchedules[0]];
          return;
        }

        for (let item of dataSchedules) {
          // 確定しているスケジュールを表示してしまうと修正できないので飛ばす
          if (item.zz_reservation_status_1_id !== "5") {
            this.schedules = [item];
            return;
          }
        }

        //this.schedules = [dataSchedules[0]];
      }
    },
    canBeConfirm(schedule) {
      // 予約情報画面では確定不可能
      // 確定済みは確定不可能
      // キャンセル中は確定不可能
      // 最低限エラーチェックはしているので個々のでチェックはある程度にして押させてしまっていいか
      return this.isAccessByCarManager 
      && this.canUserEdit() 
      && ![this.$constant.zz_reservation_status_1.confirm
        ,this.$constant.zz_reservation_status_1.cancel
        ,this.$constant.zz_reservation_status_1.change_request
      ].includes(schedule.zz_reservation_status_1_id)
      && this.schedule_id
    },
    canBeCancel(schedule) {
      return this.isAccessByCarManager && this.canUserEdit() && !schedule['new']
        && ![this.$constant.zz_reservation_status_1.confirm].includes(schedule.zz_reservation_status_1_id)
    },
    canBeUpdate(schedule) {
      if (!schedule) return false;

      return ![this.$constant.zz_reservation_status_1.confirm, this.$constant.zz_reservation_status_1.cancel]
        .includes(schedule.zz_reservation_status_1_id)
    },
    canBeViewHistories(schedule) {
      return !schedule['new'];
    },
    disableByWorkOrder(schedule){
      //・作業分類：処分
      //・作業分類：排出 の他社運搬
      //・作業分類：積替保管 の他社運搬 (区間1,2共通)
      // 従業員・車両選択をOFF
      return (schedule.zz_work_order_type_id == this.$constant.work_order_type.disposal) ||
      (schedule.zz_work_order_type_id == this.$constant.work_order_type.discharge && 
      (schedule.vendor !== undefined && schedule.vendor.zz_own_id == this.$constant.zzOwnId.is_not_own)
      ) ||
      (schedule.zz_work_order_type_id == this.$constant.work_order_type.transshipment_storage && 
      (schedule.vendor !== undefined && schedule.vendor.zz_own_id == this.$constant.zzOwnId.is_not_own)
      )
    },
    openHistoryModal(schedule) {
      if (!this.isAccessByCarManager) return;
      this.$refs.modal_history.openModal(schedule.id);
    },
    async onSubmit(updateType = 'all', onlyValidation = true, fromCarOverlap = false) {
      this.errors = {};
      const schedules = this.$_.cloneDeep(this.schedules);
      schedules.forEach(item => {
        if (this.isAccessByCarManager) {
          item.start_time = this.regularInformation.start_time;
          item.end_time = this.regularInformation.end_time;
        }
        delete item.waste_or_services_by_schedule.waste_estimates_by_work_reservation;
      })

      // サービス・廃棄物見積明細のうち少なくとも1つは入力しているかチェック
      for (let index_1 = 0; index_1 < schedules[0].waste_or_services_by_schedule.length; index_1++) {
        const wasteOrServiceBySchedule = schedules[0].waste_or_services_by_schedule[index_1];
        let sumQuantity = 0;
        wasteOrServiceBySchedule.waste_estimates_by_schedule.forEach(estimate => {
          const quantity = estimate.quantity ? parseFloat(estimate.quantity) : 0;
          sumQuantity += quantity;
        })

        if(sumQuantity === 0) {
          for(let index_2 = 0; index_2 < wasteOrServiceBySchedule.waste_estimates_by_schedule.length; index_2++) {
            this.errors['schedules.0.waste_or_services_by_schedule.' + index_1 + '.waste_estimates_by_schedule.' + index_2 + '.quantity'] = ['少なくとも1つ数量を入力してください。'];
          }
          if(wasteOrServiceBySchedule.waste_estimates_by_schedule.length == 1) {
            this.errors['schedules.0.waste_or_services_by_schedule.' + index_1 + '.waste_estimates_by_schedule.0.quantity'] = ['0より大きい数字を入力してください。'];
          }
          return;
        }
      }

      let params = {
        work_reservation: {
          id: this.workReservation.id,
        },
        schedules: schedules,
        update_type: updateType,
        is_schedule_selected: this.sourceFromCalendar, 
        regular_interval_information: this.regularInformation,
        only_validation: onlyValidation,
        update_request : this.update_request,
        schedule_id: this.schedule_id,
        from_car_overlap: fromCarOverlap
      };

      const url = apiEndpoints.update_regular_schedules_by_work_reservation(this.workReservationId)

      const {status, data, code} = await this.$http.post(url, params);

      if (status) {
        // バリデーション時、もしくは車両重複ダイアログから来てコンプライアンスエラーがある場合のみ
        if (onlyValidation || (fromCarOverlap && data.result.compliance_valid===false)) {
          return this.handleConfirmUpdate(updateType,data);
        }
        this.successToast("予約の修正が成功しました。", false, 2000);
        this.backToList();
      }

      if (this.$helpers.isDisplayFormError(code)) {
        this.errors = data.errors;
        if (this.errors['overlap_schedules'] && this.errors['overlap_schedules'].length) {
          this.handleOverlapSchedulesError(updateType, this.errors['overlap_schedules']);
        }
        return this.$nextTick(() => {
          this.scrollIntoError();
        });
      } else if (this.$helpers.isDisplayErrorInLocalComponent(code)) {
        return this.errorToast(data.message, false, 3000);
      }
    },
    handleConfirmUpdate(updateType,data) {

      let confirmMsg = "";
      let width ='32em';
      if(data.result.message){
        confirmMsg+=data.result.message+"<br>";
        width='50em';
      }
      confirmMsg+='登録してもよろしいですか。';
      this.confirm(
        confirmMsg,
        '',
        '',
        'info',
        'OK',
        'キャンセル',
        true,
        '#d33',
        width
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.onSubmit(updateType, false);
        }
      });
    },
    handleOverlapSchedulesError(updateType, errors) {
      let message = [
          ...errors,
        'の車両に作業日時の重複があります。',
        '登録してよろしいですか？',
      ].join('<br>');
      this.confirm(
        '',
        '',
        message,
        'warning',
        'OK',
        'キャンセル'
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.onSubmit(updateType, false, true);
        }
      });
    },
    onChangeOrRequest() {
      this.confirm(
        '',
        '',
        '変更・キャンセル依頼を登録してもよろしいですか。',
        'info',
        'OK',
        'キャンセル',
        true,
        "#d33",
        "35em"
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.saveHistories();
        }
      });
    },
    async saveHistories() {
      if (!this.isAccessBySale) return;
      const schedules = this.$_.cloneDeep(this.schedules);
      schedules.forEach(item => {
        item.waste_or_services_by_schedule.forEach(x => {
          delete x.waste_or_service_by_work_order
        })
        delete item.waste_or_services_by_schedule.waste_estimates_by_work_reservation;
        delete item.waste_or_services_by_schedule.waste_or_service_by_work_order;
      })
      let params = {
        work_reservation: {
          id: this.workReservation.id,
          work_order_update_requests: this.workReservation.work_order_update_requests,
        },
        schedules: schedules,
        schedule_id: this.schedule_id,
      };
      const {status, code, data} = await this.$http.post(apiEndpoints.save_histories_regular_schedules_by_sale(this.workReservationId), params);
      if (!status) {
        if (this.$helpers.isDisplayFormError(code)) {
          this.errors = data.errors;
          return this.$nextTick(() => {
            this.scrollIntoError();
          });
        } else if (this.$helpers.isDisplayErrorInLocalComponent(code)) {
          return this.errorToast(data.message);
        }
      }

      this.successToast("変更・キャンセル依頼を登録しました", false, 2000);
      this.backToList();
    },

    onConfirmSchedule(schedule){
      this.confirm(
        '',
        '',
        '確定してもよろしいですか。',
        'info',
        'OK',
        'キャンセル',
        true,
        "#d33",
        "35em"
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.confirmSchedule(schedule);
        }
      });
    },

    async confirmSchedule(schedule) {
      if (!this.isAccessByCarManager) return;
      this.isLoading = true
      const url = apiEndpoints.schedule_confirm();
      let listId = [];
      listId.push(schedule.id);
      let targetDate = schedule.start_datetime;
      let start_datetime = schedule.start_datetime;
      let end_datetime = schedule.end_datetime;
      let type = this.tab;
      let eventLength = 1;
      
      const { status, data } = await this.$http.post(url, 
      {
        start_datetime: start_datetime
        , end_datetime:end_datetime
        , type:type 
        , ids: listId
        , targetDate: targetDate
        , allEventsLength: eventLength
      });
      const isSuccessDataExists = status && data.result && data.result.schedules && data.result.schedules.length;
      if (isSuccessDataExists && !data.result.contract_warning) {
        // コンプラチェックエラーなし & 確定したものあり  
        this.successToast("受付番号 "+ schedule.id + " の配車を確定しました", false, 3000);
      } else {
        if (data.result.contract_warning) {
          // コンプラチェックエラーダイアログ表示
          this.$swal.fire({
            icon: "warning",
            html: data.result.contract_warning_message,
            width: data.result.width_alert || '70em',
          })
          .then(() => {
            // その後、確定したものがあればwarningのtoast表示
            if (isSuccessDataExists) {
              this.warningToast(eventDateMD + " 配車が確定できませんでした", false, 3000);
            }
          });
        }
      }

      this.isLoading = false;
      this.reloadSchedules();
    },

    onCancelSchedule(schedule){

      let cancelLabel = schedule.zz_reservation_status1.id == this.$constant.zz_reservation_status_1.cancel ? 'キャンセル解除':'キャンセル';

      this.confirm(
        '',
        '',
        cancelLabel + 'してもよろしいですか。',
        'info',
        'OK',
        'キャンセル',
        true,
        "#d33",
        "35em"
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.cancelSchedule(schedule);
        }
      });
    },
    async cancelSchedule(schedule) {
      if (!this.isAccessByCarManager) return;
      let params = {
        schedules: this.schedules,
      };
      const {status, code, data} = await this.$http.post(apiEndpoints.cancel_schedule_by_car_manager(schedule.id), params)
      if (!status) {
        return this.errorToast(data.message);
      }
      this.reloadSchedules();
    },
    reloadSchedules() {
      this.getSchedules();
    },
    scrollIntoError() {
      const el = document.querySelector(".error-message");
      el.scrollIntoView({behavior: "smooth", block: "center", inline: "start"});
    },
    canUpdateZzReservationStatus2(schedule) {
      return !schedule.new && schedule.can_update_zz_reservation_status_2;
    },
    onClickUpdateByCarManager() {
      if (this.sourceFromCalendar) {
        this.openModalConfirm();
        return;
      }
      this.onSubmit();
    },
    onClickDeleteByCarManager() {
      if (this.sourceFromCalendar) {
        this.openModalConfirmDelete();
        return;
      }

      this.confirm(
        '',
        '',
        '予約情報を削除してもよろしいですか。',
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.deleteAllSchedule();
        }
      });
    },
    openModalConfirm() {
      this.$refs.modalConfirmRegularUpdate.openModal();
    },
    openModalConfirmDelete() {
      this.$refs.modalConfirmRegularDelete.openModal();
    },
    onSubmitConfirm(value) {
      this.onSubmit(value);
    },
    onSubmitConfirmDelete(value) {
      if (value === 'single') {
        return this.deleteSchedule()
      }

      return this.deleteAllSchedule()
    },
    async deleteSchedule() {
      if (!this.schedules.length) return;

      const scheduleId = this.schedules[0].id;
      const {status, code, data} = await this.$http.post(apiEndpoints.delete_schedule_by_car_manager(scheduleId));

      if (!status) {
        return this.errorToast(data.message);
      }
      this.backToList();
    },
    async deleteAllSchedule() {
      if (!this.schedules.length) return;

      let params = {
        schedules: this.schedules,
        is_schedule_selected: this.sourceFromCalendar
      };

      const {status, code, data} = await this.$http.post(apiEndpoints.delete_regular_schedule_by_car_manager(this.workReservationId), params);

      if (!status) {
        return this.errorToast(data.message);
      }

      this.successToast("予約情報を削除しました", false, 3000);
      this.backToList();
    },
    setMinNumber (e, number = 0) {
      if (e.target.value < number) e.target.value = number;
    },
    quantityConfirmationUnit(wasteOrService) {
      if (!wasteOrService.zz_quantity_confirmation_unit) return '';

      return wasteOrService.zz_quantity_confirmation_unit.jw_unit;
    },
    isDisplayMeasurementQuantity(wasteOrService) {
      return wasteOrService.measurement_quantity !== null
        && wasteOrService.measurement_quantity !== undefined
        && wasteOrService.zz_quantity_confirmation_unit;
    },
    isTransportAndHold(schedule) {
      return schedule.zz_work_order_type_id == this.$constant.work_order_type.transshipment_storage;
    },
    isScheduleConfirmed(){
      return (this.schedules.filter(schedule => schedule.zz_reservation_status_1_id 
      == this.$constant.zz_reservation_status_1.confirm).length > 0);
    },
    isNotOwnVendorSite(wasteOrService, schedule) {
      if (this.isTransportAndHold(schedule) && schedule.transport_and_hold_section === 2) {
        // 積替保管区間2の場合は他社処分
        return true;
      }
      // それ以外は区間1の運搬先の委託先事業場の自社フラグで判定
      return wasteOrService.disposal_site?.disposal_site_by_waste_category?.vendor_site_of_treatment.zz_own_id === '0';
    },
    viewSchedules(){
      // 配車側でかつ変更依頼時
      return (this.isAccessByCarManager && this.update_request == "1");
    },
    getScheduleList(){
      const stageOption = this.allSchedule ?? [];
      return stageOption.map(obj => ({
        text: '[' + obj.id + ']' + 
        this.$moment(obj.start_datetime).locale('ja').format('YYYY年MM月DD日（ddd）') +
        '(' + obj.zz_reservation_status1.reservation_status_1 + ')',
        value: obj.id,
      }));
    },
    openSchedule(){
      let router = this.$router.resolve({name: 'projects.work_reservations.schedule.detail', params:{work_reservation_id:this.selectedSchedule}});
      //window.open(router.href, '_blank');
      this.redirectRouteTargetBlank(
        'projects.work_reservations.schedule.detail',
        {
          work_reservation_id: this.$route.params.work_reservation_id,
              },
              {
                source: 'calendar', // ソースがcalendarじゃないとスケジュール情報部分に日付が表示されない
                schedule_id: this.selectedSchedule,
                zz_reservation_frequency_type_id: 2,
                // tab:this.$route.query.type,
              },
              this.$route.query,
              'projects/work-reservations/schedules'
      );
    }
  },
  computed: {
    source() {
      return this.$route.query.source;
    },
    sourceFromCalendar() {
      return this.source === 'calendar';
    },
    scheduleId() {
      return this.$route.query.schedule_id;
    },
    previousRouteName() {
      if (this.$route.name === 'projects.work_reservations.schedule.detail_for_sale') {
        return 'schedules';
      }

      return 'schedule.car.list';
    },
    isAccessBySale() {
      return this.$route.name === 'projects.work_reservations.schedule.detail_for_sale'
    },
    isAccessByCarManager() {
      return this.$route.name === 'projects.work_reservations.schedule.detail'
    },
    zz_regularly_reservation_intervals() {
      return (
        this.$store.getters["options/options_tables"]
          .zz_regularly_reservation_intervals ?? []
      );
    },
    displayScheduleDateTime() {
      if (this.schedules.length === 0) {
        return '';
      }
      return this.$moment(this.schedules[0].start_datetime).locale('ja').format('YYYY年MM月DD日（ddd）HH:mm')
          + ' ～ '
          + this.$moment(this.schedules[0].end_datetime).locale('ja').format('HH:mm');
    },
  },
  watch: {
    schedules: {
      handler: function(newVal) {
        if (!newVal || !newVal.length || !this.workReservation) return;
        this.mappingData(this.workReservation);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<template>
  <Layout>
    <div class="scroll-area">
      <WorkOrderInformationComponent
        v-if="workReservation && workReservation.work_order"
        :workOrder="workReservation.work_order"
      />
      <WorkReservationInformationComponent
        v-if="workReservation"
        :work-reservation="workReservation"
        :waste-or-services-by-work-reservation="workReservation.wastes_or_services_by_work_reservation"
        :disable-comment="disableComment"
        :display-user-created="isAccessByCarManager"
        :display-time-reservation-date="isAccessByCarManager"
      />
      <b-card v-if="viewSchedules()">
        <b-row class="mb-2"><b-col>ここは「定期予約情報」の変更画面です。個別のスケジュールを変更する場合、以下から該当のスケジュールを選択して開いた画面で行ってください。</b-col></b-row>
        <b-row>
          <b-col>
            <div class="title">
              ■スケジュール選択 
            </div>
        </b-col>
        <b-col>
        <b-form-select 
            :options="getScheduleList()"
            id="manifest-status-id"
            v-model="selectedSchedule"
            class="form-select custom-select"
            />
          </b-col>
          <b-col>
            <button class="btn btn-primary mr-1" @click="openSchedule">
              開く
            </button>
          </b-col>
          <b-col></b-col>
        </b-row>
      </b-card>
      <ModalHistory
        v-if="isAccessByCarManager"
        ref="modal_history"
      />
      <ModalScheduleCar
        v-if="isAccessByCarManager"
        ref="vehicleList"
        @dataSelected="onSelectedVehicles"
      />
      <ModalScheduleStaff
        v-if="isAccessByCarManager"
        ref="staffList"
        @dataSelected="onSelectedStaffs"
      />
      <ModalTransportTreatment
        v-if="isAccessByCarManager"
        ref="transportsTreatments"
        @dataSelected="onSelectedTransportTreatment"
      />
      <ModalConfirmRegularUpdate
        ref="modalConfirmRegularUpdate"
        @submit="onSubmitConfirm"
      />
      <ModalConfirmRegularDelete
        ref="modalConfirmRegularDelete"
        @submit="onSubmitConfirmDelete"
      />
      <ModalSelectWasteOrServiceModalForSchedule
        ref="modalSelectWasteOrService"
        :work-order-id="workReservation.work_order_id"
        @dataSelected="onSelectedWastesOrService"
      />
      <div class="mb-2">
        <b-button
          variant="primary"
          :disabled="!canAddWasteOrService"
          @click="openSelectWasteOrServiceModal()"
          v-if="canUserEdit()"
          >
          <i class="fa fa-plus"></i>
          廃棄物・サービスを追加する
        </b-button>
      </div>
      <b-card
        v-for="(schedule, index) in schedules"
        class="reservation-reception"
        :key="`schedule_${schedule.id}`"
      >
        <div
          v-if="errors[`schedules.${index}`]"
          class="error-message"
        >
          {{ errors[`schedules.${index}`][0] }}
        </div>
        <b-row class="mb-2">
          <b-col cols="6">
            <div class="title">■ 予約受付内容</div>
          </b-col>
        </b-row>
        <b-row class="mt-1 mb-3">
          <b-col v-if="sourceFromCalendar && schedules.length > 0">
            <div class="d-flex gap-2">
              <div class="flex-grow-1">
                <span class="mr-2">選択中のスケジュール</span>
                <span>{{ displayScheduleDateTime }}</span>
              </div>
              <div class="gap-2">
              <b-button
                variant="success"
                v-if="canBeConfirm(schedule)"
                @click="onConfirmSchedule(schedule)"
                style="margin-right: 5px;"
              >
                <i class="fas fa-check"></i> 確定
              </b-button>
                <b-button
                  variant="warning"
                  v-if="canBeCancel(schedule)"
                  @click="onCancelSchedule(schedule)"
                  style="margin-right: 5px;"
                >
                  <i class="fas fa-times"></i> {{ buttonCancelText }}
                </b-button>
                <b-button
                  v-if="canBeViewHistories(schedule)"
                  :disabled="isAccessBySale"
                  @click="openHistoryModal(schedule)"
                  variant="info"
                >
                  <i class="fas fa-history"></i> 履歴
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="1">受付番号</b-col>
          <b-col class="d-flex gap-2">
            <div>{{ !schedule.new ? schedule.id : '' }}</div>
            <ZzReservationStatus1Badge
              v-if="schedule.zz_reservation_status1"
              :status-label="schedule.zz_reservation_status1.reservation_status_1"
              :status-id="schedule.zz_reservation_status1.id"
            />
            <div
              v-if="isTransportAndHold(schedule)"
              class="badge transport_and_hold"
            >
              区間{{ schedule.transport_and_hold_section }}
            </div>
            <ZzReservationStatus2Badge
              v-if="schedule.zz_reservation_status2"
              :status-label="schedule.zz_reservation_status2.reservation_status_2"
              :status-id="schedule.zz_reservation_status2.id"
            />
          </b-col>
        </b-row>
        <div class="mt-2 mb-1 d-flex flex-wrap col-gap-5">
          <div class="me-4">
            <span>定期予約</span>
          </div>
          <ScheduleRegularIntervalInformationBySale
            v-if="workReservation && isAccessBySale"
            :work-reservation="workReservation"
            :regular-information="regularInformation"
          />
          <ScheduleRegularIntervalInformationByCarManager
            :errors="errors"
            v-else
            :data-selected="regularInformation"
            :disabled="!canBeUpdate(schedules[0])"
          />
          <div
            v-if="errors[`schedules.${index}.start_datetime`]"
            class="error-message text-nowrap"
          >
            {{ errors[`schedules.${index}.start_datetime`][0] }}
          </div>
        </div>
        <b-row v-if="schedule.vendor && schedule.vendor.zz_own_id === '0'" class="mt-4 mb-2">
          <b-col>
            運搬事業者：{{ schedule.vendor.name_abbreviated }}
          </b-col>
        </b-row>
        <b-button
          :disabled="isAccessBySale || !canBeUpdate(schedule) || disableByWorkOrder(schedule) || !canUserEdit()"
          variant="primary mt-2"
          @click="openSelectAssignedCarsModal(schedule)"
        >
          <i class="fa fa-list-alt"></i>
          車両を選択する
        </b-button>
        <div class="selected-vehicles d-flex gap-2 mt-2 flex-wrap">
          <b-badge
            v-for="(assigned_car, indexCar) in schedule.assigned_cars_by_schedule"
            :key="`assigned_car_${schedule.id}_${assigned_car.id}`"
            variant="primary"
          >
            {{ displayAssignedCar(assigned_car) }}
            <span
              v-if="isAccessByCarManager"
              @click="removeAssignedCar(schedule, assigned_car)"
              class="badge badge-light badge-icon-custom"
            >×</span>
          </b-badge>
        </div>
        <b-button
          :disabled="isAccessBySale || !canBeUpdate(schedule) || disableByWorkOrder(schedule) || !canUserEdit()"
          variant="primary mt-2"
          @click="openSelectAssignedStaffsModal(schedule)"
        >
          <i class="fa fa-list-alt"></i>
          従業員を選択する
        </b-button>
        <div class="selected-employees d-flex gap-3 mt-2">
          <b-badge
            v-for="(staff, indexStaff) in schedule.assigned_staffs_by_schedule"
            :key="`staff_${schedule.id}_${staff.id}`"
            variant="primary"
          >
            {{ staff.user_name }}
            <span
              v-if="isAccessByCarManager"
              @click="removeAssignedStaff(schedule, staff)"
              class="badge badge-light badge-icon-custom"
            >×</span>
          </b-badge>
        </div>
        <div
          v-if="errors[`schedules.${index}.assigned_staffs_by_schedule`]"
          class="error-message text-nowrap"
        >
          {{ errors[`schedules.${index}.assigned_staffs_by_schedule`][0] }}
        </div>
        <div class="custom-radio-group mt-3" v-if="canUpdateZzReservationStatus2(schedule)">
          <b-form-radio-group
            :disabled="isAccessBySale || !canBeUpdate(schedule)"
            class="radio-group"
            :id="`zz_reservation_status_${index}`"
            text-field="reservation_status_2"
            value-field="id"
            v-model="schedule.zz_reservation_status_2_id"
            :options="zzReservationStatus2"
          ></b-form-radio-group>
        </div>
        <div class="d-flex gap-5 mt-2">
          <div class="d-flex gap-2">
            <div>合積</div>
            <b-form-checkbox
              :disabled="isAccessBySale || !canBeUpdate(schedule)"
              :id="`is_mixed_loading_kbn${index}`"
              v-model="schedule.is_mixed_loading_kbn"
              :value="schedule.is_mixed_loading_kbn"
              :name="`is_mixed_loading_kbn${index}`"
              value="1"
              unchecked-value="0"
            >
              あり
            </b-form-checkbox>
          </div>
          <div class="d-flex gap-2">
            <div>合積受付番号</div>
            <div>
              <b-form-input
                type="number"
                v-model="schedule.schedule_id_of_mixed_loading"
                :disabled="isAccessBySale || !canBeUpdate(schedule)"
              />
              <div
                v-if="errors[`schedules.${index}.schedule_id_of_mixed_loading`]"
                class="error-message"
              >
                {{ errors[`schedules.${index}.schedule_id_of_mixed_loading`][0] }}
              </div>
            </div>
          </div>
        </div>
        <div class="title mt-2">■ 作業内容</div>
        <div
          v-for="(waste_or_service_by_schedule, index_waste_or_service) in schedule.waste_or_services_by_schedule"
          :key="`waste_or_service_by_schedule_${schedule.id}_${waste_or_service_by_schedule.id}`"
          class="work-detail mt-2 mb-4"
        >
          <div class="infomations d-flex gap-3">
            <div class="number">{{ index_waste_or_service + 1 }}.</div>
            <div class="waste-work-name">廃棄物・サービス名
              <template v-if="waste_or_service_by_schedule.waste_or_service_by_work_order.waste">
              <router-link
                class="text-decoration-underline"
                target="_blank"
                :to="{ name: 'projects.sales.wastes.detail',
                    params: {
                      id: waste_or_service_by_schedule.waste_or_service_by_work_order.waste.case_id,
                      waste_id: waste_or_service_by_schedule.waste_or_service_by_work_order.waste.id}
                }">
                <span>{{
                  displayWasteOrServiceName(waste_or_service_by_schedule)
                }}</span>
                </router-link>
                </template>
                <template v-else>
                <router-link
                  class="text-decoration-underline"
                  target="_blank"
                  :to="{ name: 'projects.sales.works.detail',
                      params: {
                        id: waste_or_service_by_schedule.waste_or_service_by_work_order.service.case_id,
                        work_id: waste_or_service_by_schedule.waste_or_service_by_work_order.service.id}
                  }">
                  <span>{{
                    displayWasteOrServiceName(waste_or_service_by_schedule)
                  }}</span>
                  </router-link>
                </template>
            </div>
            <template v-if="waste_or_service_by_schedule && waste_or_service_by_schedule.waste_or_service_by_work_order.waste">
              <div class="waste-type">
                廃棄物種類
                <span>{{ displayWasteCategory(waste_or_service_by_schedule) }}</span>
              </div>
              <div class="manifest">
                <label class="label-manifest">マニフェスト</label>
                <b-form-input
                        :disabled="isAccessBySale || !canBeUpdate(schedule)"
                        @keyup="setMinNumber($event)"
                        :id="`waste_or_service_by_schedule_number_of_manifest_${waste_or_service_by_schedule.id}`"
                        type="number"
                        min="0"
                        v-model="waste_or_service_by_schedule.number_of_manifest"
                        class="input-manifest"
                ></b-form-input>
                <span>枚</span>
                <template
                  v-if="errors[`schedules.${index}.waste_or_services_by_schedule.${index_waste_or_service}.number_of_manifest`]"
                >
                  <br>
                  <span class="error-message">{{ errors[`schedules.${index}.waste_or_services_by_schedule.${index_waste_or_service}.number_of_manifest`][0] }}</span>
                </template>
              </div>
              <div class="measurement-quantity" v-if="isDisplayMeasurementQuantity(waste_or_service_by_schedule)">
                予定重量
                <span>{{waste_or_service_by_schedule.measurement_quantity | number}}</span>
                <span>{{quantityConfirmationUnit(waste_or_service_by_schedule)}}</span>
              </div>
            </template>
          </div>
          <template v-if="waste_or_service_by_schedule && waste_or_service_by_schedule.waste_or_service_by_work_order.waste">
            <div class="d-flex gap-2 transport-destination mt-2 align-items-center w-50">
              <div class="label text-nowrap">運搬先・処分方法</div>
              <b-form-input
                disabled
                :value="getDestinationWasteOrServiceBySchedule(waste_or_service_by_schedule, schedule)"
              ></b-form-input>
              <b-button
                @click="openSelectTransportTreatmentModal(waste_or_service_by_schedule, schedule)"
                :disabled="isAccessBySale || isNotOwnVendorSite(waste_or_service_by_schedule, schedule) || !canBeUpdate(schedule) || !canUserEdit()"
                variant="primary text-nowrap">
                <i class="fa fa-list-alt"></i>
                変更
              </b-button>
            </div>
          </template>
          <div class="mt-3">
            <CommonTableComponent
              :height-class="`table-wrapper-500`"
            >
              <thead class="table-light">
              <tr>
                <th
                  v-for="(header, indexHeader) in work_detail_header"
                  :key="`table_wastes_or_services_by_work_reservation_header_${schedule.id}_${indexHeader}`"
                  :class="getHeaderClass(header)"
                >
                <span>
                  {{ header.text }}
                </span>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr
                v-for="(waste_estimate_by_schedule, index_waste_estimates_by_schedule) in waste_or_service_by_schedule.waste_estimates_by_schedule"
                :key="`waste_estimate_by_schedule_${schedule.id}_${waste_or_service_by_schedule.id}_${waste_estimate_by_schedule.id}`"
              >
                <td>
                  {{ waste_estimate_by_schedule.estimate_cd }}
                </td>
                <td>
                  {{ waste_estimate_by_schedule.invoice_product_name }}
                </td>
                <td>
                  <template v-if="isAccessByCarManager">
                  <b-form-input
                    :disabled="!canBeUpdate(schedule)"
                    @keyup="setMinNumber($event)"
                    :id="`waste_estimates_by_schedule_quantity_${waste_estimate_by_schedule.id}`"
                    type="number"
                    min="0"
                    v-model="waste_estimate_by_schedule.quantity"
                  ></b-form-input>
                  <div
                    v-if="errors[`schedules.${index}.waste_or_services_by_schedule.${index_waste_or_service}.waste_estimates_by_schedule.${index_waste_estimates_by_schedule}.quantity`]"
                    class="error-message"
                  >
                    {{ errors[`schedules.${index}.waste_or_services_by_schedule.${index_waste_or_service}.waste_estimates_by_schedule.${index_waste_estimates_by_schedule}.quantity`][0] }}
                  </div>
                  </template>
                  <template v-else>
                    {{ waste_estimate_by_schedule.quantity }}
                  </template>
                </td>
                <td>
                  {{ waste_estimate_by_schedule.zz_unit.unit }}
                </td>
                <td>
                  <template v-if="isAccessByCarManager">
                    <b-form-input
                      :disabled="!canBeUpdate(schedule) || !waste_or_service_by_schedule.waste_or_service_by_work_order.waste_id"
                      :id="`waste_estimates_by_schedule_number_of_rental_containers${waste_estimate_by_schedule.id}`"
                      type="text"
                      maxLength="50"
                      v-model="waste_estimate_by_schedule.number_of_rental_containers"
                    ></b-form-input>
                    <div
                      v-if="errors[`schedules.${index}.waste_or_services_by_schedule.${index_waste_or_service}.waste_estimates_by_schedule.${index_waste_estimates_by_schedule}`]"
                      class="error-message"
                    >
                      {{ errors[`schedules.${index}.waste_or_services_by_schedule.${index_waste_or_service}.waste_estimates_by_schedule.${index_waste_estimates_by_schedule}`][0] }}
                    </div>
                  </template>
                  <template v-else>
                    {{ waste_estimate_by_schedule.number_of_rental_containers }}
                  </template>

                </td>
              </tr>
              <tr v-if="!waste_or_service_by_schedule.waste_estimates_by_schedule.length">
                <td colspan="6" class="text-center">
                  データなし。
                </td>
              </tr>
              </tbody>
            </CommonTableComponent>
          </div>
          <div class="mt-1">
            <label>事業者向け備考</label>
            <b-form-textarea
              :disabled="isAccessBySale"
              rows="2"
              max-rows="6"
              v-model="waste_or_service_by_schedule.comment_to_discharger_site_user"
            ></b-form-textarea>
          </div>
          <div class="mt-1">
            <label>作業者向け備考</label>
            <b-form-textarea
              :disabled="isAccessBySale"
              rows="2"
              max-rows="6"
              v-model="waste_or_service_by_schedule.comment_to_user"
            ></b-form-textarea>
          </div>
        </div>
      </b-card>
      <b-card class="comment-fixed-custom">
        <div class="title">■ 変更依頼コメント</div>
        <b-form-input
          :disabled="disableComment"
          id="comment_reservation"
          v-model="workReservation.work_order_update_requests"
        />
        <div
          v-if="errors[`work_reservation.work_order_update_requests`]"
          class="error-message"
        >
          {{ errors[`work_reservation.work_order_update_requests`][0] }}
        </div>
      </b-card>
    </div>
    <div class="button-fixed-custom">
      <div class="list-button d-flex gap-2">
        <template v-if="isAccessBySale && canUserEdit()">
          <b-button
            @click="onChangeOrRequest()"
            variant="warning"
            class="change-cancel-button"
            >
            <i class="fas fa-pencil-alt"></i> 変更・キャンセル依頼
          </b-button>
          <router-link
            :to="{ name: previousRouteName }"
            tag="button"
            class="btn btn-primary waves-effect waves-light back-button"
          >
            <i class='far fa-arrow-alt-circle-left'></i> {{ this.$lang.button.back }}
          </router-link>
        </template>
        <template v-else>
          <b-button
            :disabled="!schedules.length || !canBeUpdate(schedules[0])"
            variant="primary"
            @click="onClickUpdateByCarManager()"
            v-if="canUserEdit()"
          >
          <i class="fas fa-pencil-alt"></i> 登録
          </b-button>
          <router-link
            :to="{ name: previousRouteName }"
            tag="button"
            class="btn btn-primary waves-effect waves-light"
          >
            <i class='far fa-arrow-alt-circle-left'></i> {{ this.$lang.button.back }}
          </router-link>
          <div class="d-flex justify-content-end delete-button-area">
            <b-button
            :disabled="!schedules.length || !canBeUpdate(schedules[0])"
            @click="onClickDeleteByCarManager()"
            class="btn-custom-red delete-button"
            v-if="canUserDelete()"
          >
            <i class="fas fa-eraser"></i> {{ this.$lang.button.delete }}
            </b-button>
          </div>
        </template>
      </div>

    </div>
  </Layout>
</template>

<style scoped lang="scss">
.scroll-area {
  max-height: calc(100vh - 150px);
  overflow-y: auto;
  overflow-x: hidden;
}

.work-instruction-content,
.reservation-contents,
.reservation-reception {
  .title {
    font-size: 16px;
    font-weight: 700;
  }
}

.work-instruction-content {
  .block-1,
  .block-2 {
    div > span {
      margin-left: 10px;
    }
  }

  .block-1 {
    a {
      text-decoration: underline !important;
      color: #495057;
    }
  }

  .block-3 {
    gap: 30px;

    .number-of-workers {
      margin-right: 20px;

      span {
        margin-left: 20px;
      }
    }
  }

  .block-4 {
    .vehicle-list {
      margin-left: 48px;
    }
  }
}

.reservation-contents {
  .block-1,
  .block-2 {
    div > span {
      margin-left: 10px;
    }
  }

  .block-5,
  .block-6 {
    span {
      margin-left: 10px;
    }
  }
}

.reservation-reception {
  .work-detail {
    .infomations {
      div > span {
        margin-left: 5px;
      }

      .waste-work-name {
        margin-left: 10px;
      }

      .waste-type, .manifest, .measurement-quantity {
        margin-left: 20px;
      }

      .manifest {
        margin-top: -10px;
      }
    }
  }

  .transport-destination {
    margin-left: 35px;
  }
}

.badge {
  font-size: 14px;
  padding: 8px 16px;
  background-color: #14A5FD;
}

.badge.badge-icon-custom {
  color: #14A5FD;
  padding: 2px 4px;
  background-color: #f8f9fa;
  border-radius: 50%;
  font-weight: 700;
  cursor: pointer;
}

.transport_and_hold {
  background-color: #891457;
}

.custom-radio-group .radio-group {
  margin-left: unset;
}

.multiselect {
  width: 60%;
}

.button-fixed-custom {
  position: fixed;
  left: 50%;
  bottom: 0;
  z-index: 10;
  margin-bottom: 20px;
  width:50%;
}
.lbl-custom {
  font-weight: 600;
}

.title-detail {
  font-size: 16px;
  font-weight: 600;
}
.comment-fixed-custom {
  position: sticky;
  z-index: 10;
  bottom: 0;
  border-top: 2px solid #eff2f7;
}

.delete-button-area {
  width: 79%;
}

.delete-button {
  width: 72px;
}

.change-cancel-button {
  width: 200px;
}

.back-button {
  width: 77px;
}

.input-manifest {
  display: inline;
  width: 65px;
  margin-left: 10px;
}
</style>
